import React from "react";
import { Container, Box } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import SectionHeader from "../../common/SectionHeader";
import { logger } from '../../../utils/logger';

const FPACalendarSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        title="FP&A Calendar"
        variant="h2"
        icon={<Icon name="calendar" />}
        useGradient={true}
      />
      <Container>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "800px",
          }}
        >
          <iframe
            src="https://starmap.fgbs.amazon.dev/"
            style={{
              width: "100%",
              height: "100%",
              border: "1px solid #ccc",
              borderRadius: "8px",
            }}
            title="Starmap"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            onLoad={() => logger.info("Iframe loaded successfully")}
            onError={() => logger.error("Iframe failed to load")}
          />
        </div>
      </Container>
    </Box>
  );
};

export default FPACalendarSection;
